import { render, staticRenderFns } from "./ProfessionPageSectionProfessionTask.vue?vue&type=template&id=277d3bfc&scoped=true"
import script from "./ProfessionPageSectionProfessionTask.vue?vue&type=script&lang=js"
export * from "./ProfessionPageSectionProfessionTask.vue?vue&type=script&lang=js"
import style0 from "./ProfessionPageSectionProfessionTask.vue?vue&type=style&index=0&id=277d3bfc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "277d3bfc",
  null
  
)

export default component.exports